/* global Sys */

/**
 * The Event Handler stores listeners and dispatches events to all the listeners for a given event.
 *
 * @class Sys.EventHandler
 */
Sys.EventHandler = function() {
    this.EVENTS = {};
};

Sys.EventHandler.prototype = {

    /**
     * Enables history.
     * @type {boolean}
     */
    DEBUG: false,

    /**
     * Enables add and remove function log.
     * @type {boolean}
     */
    LOG_FUNC: false,

    /**
     * Enables dispatch event log.
     * @type {boolean}
     */
    LOG: false,

    /**
     * Enable warning logs. Available only in debug mode.
     * @type {boolean}
     */
    LOG_WARN: false,

    /**
     * Filters log. Defaults to: /(?:)/
     * @type {RegExp}
     */
    LOG_FILTER: /(?:)/,

    /**
     * Storing event history.
     * @type {Array}
     */
    history: [],

    /**
     * Shows history of all events sent through EventHandler. Only for debug purposes.
     *
     * @example
     * EventHandler.toString();            // returns all events
     * EventHandler.toString(/request:/);  // returns all requests
     *
     * @param {RegExp} [pattern] Regular expression for filtering history.
     * @returns {string} String.
     */
    toStringHistory: function(pattern) {
        var me = this,
            h = "",
            p,
            regexp = pattern || new RegExp();

        Sys.each(me.history, function(item) {
            try {
                p = JSON.stringify(item.params);
            }
            catch (e) {
                p = item.params;
            }

            if (regexp.test(item.event)) {
                h += item.event + " (" + item.listeners + ")" + " -> " + p + "\r\n";
            }
        });

        return h;
    },

    /**
     * Adds the listener for a given event.
     *
     * @param {Function} listener Event listener.
     * @param {string} event Event name.
     * @returns {void}
     */
    addListener: function(listener, event) {
        var me = this;

        /* DEBUG_START*/
        if (this.LOG_FUNC && this.LOG_FILTER.test(event)) {
            console.info("EventHandler: addListener -> " + event, listener);
        }

        /* DEBUG_END*/

        if (!Sys.isDefined(me.EVENTS[event])) {
            me.EVENTS[event] = [];
        }

        if (!Sys.contains(me.EVENTS[event], listener)) {
            me.EVENTS[event].push(listener);
        }
    },

    /**
     * Removes the listener for a given event.
     *
     * @param {Object} listener The class instance that listens to the event.
     * @param {string} event The name of the event.
     * @returns {void}
     */
    removeListener: function(listener, event) {
        var listeners = this.EVENTS[event] || [],
            index = listeners.indexOf(listener);

        /* DEBUG_START*/
        if (this.LOG_FUNC && this.LOG_FILTER.test(event)) {
            console.info("EventHandler: removeListener -> " + event, listener);
        }

        /* DEBUG_END*/

        if (index >= 0) {
            listeners[index] = "removed";
        }
    },

    /**
     * Dispatches the event with the optional arguments to all listeners.
     */
    dispatchEvent: Sys.variadic(function(event, parameters) {
        var listeners = this.EVENTS[event] || [],
            listenerCount = listeners.length - 1,
            i,
            listener,
            handler;

        /* DEBUG_START*/
        if (this.DEBUG) {
            this.history.push({ event: event, params: parameters, listeners: listenerCount + 1 });
        }

        /* DEBUG_END*/

        for (i = listenerCount; i >= 0; i--) {
            listener = listeners[i];
            handler = Sys.isObj(listener) ? listener.handlers[event] : null;

            if (handler) {
                handler.apply(listener, parameters);
            }

            /* DEBUG_START*/
            else if (this.LOG_WARN && this.LOG_FILTER.test(event)) {
                console.warn("EventHandler: no handler defined for: " + event + " -> ", parameters);
            }

            /* DEBUG_END*/
        }

        /* DEBUG_START*/
        if (this.LOG && this.LOG_FILTER.test(event) && listenerCount >= 0) {
            console.info("EventHandler: " + event + " -> ", parameters);
        }

        if (this.LOG_WARN && this.LOG_FILTER.test(event) && listenerCount < 0) {
            console.warn("EventHandler: no listener was defined for: " + event + " -> ", parameters);
        }

        /* DEBUG_END*/

        for (i = listenerCount; i >= 0; i--) {
            if (listeners[i] === "removed") {
                listeners.splice(i, 1);
                ++i;
            }
        }
    }),

    /**
     * Moves the listener to the first place in the array for each event it listens to.
     *
     * @param {Object} listener The listener.
     * @returns {void}
     */
    sortEventListeners: function(listener) {
        var events = this.EVENTS,
            eventKeys = Object.keys(events),
            numEvents = eventKeys.length,
            event,
            index,
            i;

        // Process each event
        for (i = -1; ++i < numEvents;) {
            event = events[eventKeys[i]];
            index = event.indexOf(listener);

            // If the listener is active for this event or is already the first element
            if (index > 0) {
                // Remove the listener from the array
                event.splice(index, 1);

                // Add the listener in the beginning of the array
                event.unshift(listener);
            }
        }
    }
};

window.EventHandler = new Sys.EventHandler();
